import request from '@/utils/request';
import { endpoints, themeEndpoint } from '@/constants/urls';

const themes = (filter, page, pageSize, otherParams) => {
  const params = {
    filter,
    page,
    pageSize,
    ...otherParams,
  };

  return (
    request({
      url: endpoints.THEMES,
      params,
      method: 'GET',
    })
  );
};

const theme = (code) => request({
  url: themeEndpoint(code),
  method: 'GET',
});

const update = ({
  code,
  name,
  description,
  enabled,
}) => request({
  url: themeEndpoint(code),
  data: {
    name,
    description,
    enabled,
  },
  method: 'PUT',
});

const updateEnabled = (code, enabled) => request({
  url: themeEndpoint(code),
  data: {
    enabled,
  },
  method: 'PUT',
});

const apply = (code) => request({
  url: `${themeEndpoint(code)}/apply`,
  method: 'PATCH',
});

const image = (code) => request({
  url: `${endpoints.IMAGES}${code}`,
  method: 'GET',
});

const ThemeService = {
  themes,
  theme,
  update,
  updateEnabled,
  apply,
  image,
};

export default ThemeService;
